// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-title.ant-typography {
  font-family: Montserrat;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  align-self: stretch;
}
@media (min-width: 376px) and (max-width: 425px) {
  .change-password-title.ant-typography {
    font-size: var(--Font-Font-Size-h5, 19px) !important;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .change-password-title.ant-typography {
    font-size: var(--Font-Font-Size-h5, 16px) !important;
  }
}
@media (min-width: 0px) and (max-width: 320px) {
  .change-password-title.ant-typography {
    font-size: var(--Font-Font-Size-h5, 15px) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/change-password-modal/ChangePassword.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE;IACE,oDAAoD;EACtD;AACF;AACA;EACE;IACE,oDAAoD;EACtD;AACF;AACA;EACE;IACE,oDAAoD;EACtD;AACF","sourcesContent":[".change-password-title.ant-typography {\n  font-family: Montserrat;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  align-self: stretch;\n}\n@media (min-width: 376px) and (max-width: 425px) {\n  .change-password-title.ant-typography {\n    font-size: var(--Font-Font-Size-h5, 19px) !important;\n  }\n}\n@media (min-width: 321px) and (max-width: 375px) {\n  .change-password-title.ant-typography {\n    font-size: var(--Font-Font-Size-h5, 16px) !important;\n  }\n}\n@media (min-width: 0px) and (max-width: 320px) {\n  .change-password-title.ant-typography {\n    font-size: var(--Font-Font-Size-h5, 15px) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
